<template>
    <div :class="[isGallery ? 'e3-folder green' : 'e3-folder orange', {'small': small, 'grid': isGrid}]">
        <EyeIcon v-if="isReadonly" :size="small ? 18 : 36" class="text-white-50"/>
    </div>
</template>

<script>
import EyeIcon from '@components/svg-icons/EyeIcon.vue';

export default {
    props: {
        isGrid: {
            type: Boolean,
            default: false
        },
        isGallery: {
            type: Boolean,
            default: false
        },
        isReadonly: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        }
    },
    components: {
        EyeIcon
    }
};
</script>

<style scoped lang="scss">
@import "@common/styles/variables/_variables.scss";

@mixin folder-large {
    margin-top: 2rem;
    min-width: 0;
    width: 65px;
    height: 42px;
    border-radius: 0 6px 6px 6px;

    &::before {
        top: -8px;
        width: 32px;
        height: 8px;
        border-radius: 6px 0 0 0;
    }

    &::after {
        top: -16px;
        left: 24px;
        border: 8px solid transparent;
    }
}

.e3-folder {
    position: relative;
    display: inline-flex;
    text-align: center;
    justify-content: center;
    align-items: center;

    margin-top: 8px;
    min-width: 34px;
    width: 34px;
    height: 20px;
    border-radius: 0 4px 4px 4px;

    &::before {
        content: '';
        display: block;
        position: absolute;
        top: -6px;
        left: 0;
        width: 16px;
        height: 6px;
        border-radius: 4px 0 0 0;
    }

    &::after {
        content: '';
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        top: -12px;
        left: 10px;
        border: 6px solid transparent;
    }

    .e3-svg {
        max-width: 100%;
        max-height: 100%;
    }

    &.small {
        margin-top: 0.2rem;
        min-height: 23px;
        min-width: 38px;
        width: auto;
        height: auto;
        border-radius: 0 4px 4px 4px;

        &::before {
            top: -6px;
            width: 17px;
            height: 6px;
            border-radius: 4px 0 0 0;
        }

        &::after {
            top: -12px;
            left: 11px;
            border: 6px solid transparent;
        }
    }

    &.grid {
        @include folder-large;
    }

    @media (min-width: $grid-br-lg) {
        &:not(.small) {
            @include folder-large;
        }
    }

    &.orange {
        background-color: $primary;

        &::before {
            background-color: darken($primary, 7%);
        }

        &::after {
            border-bottom-color: darken($primary, 7%) !important;
        }

        &:hover {
            &::before {
                background-color: lighten(darken($primary, 7%), 10%);
            }

            &::after {
                border-bottom-color: lighten(darken($primary, 7%), 10%) !important;
            }
        }
    }

    &.green {
        background-color: $success;

        &::before {
            background-color: darken($success, 7%);
        }

        &::after {
            border-bottom-color: darken($success, 7%) !important;
        }
    }
}
</style>
